module.exports = __webpack_public_path__ + "static/media/67.669ee20d.jpg";